import Vue from "vue";
import VueRouter from "vue-router";
import { getCookie } from "@/assets/js/cookie";

// 跳转路由等于当前路由会报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/home.vue"),
  },
  {
    path: "/login",
    name: "login",
    // route level code-splitting
    // this generates a separate chunk (login.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/login.vue"),
  },
  {
    path: "/list/:type_id/:test_id?",
    name: "list",
    component: () => import("../views/list.vue"),
  },

  {
    path: "/mock_intro/:mock_id",
    name: "mock_intro",
    component: () => import("../views/mock/intro.vue"),
  },
  {
    path: "/mock_answer/:id",
    name: "mock_answer",
    component: () => import("../views/mock/answer.vue"),
  },
  {
    path: "/confirm_answer/:id/:m_id/:child_class",
    name: "confirm_answer",
    component: () => import("../views/mock/confirm_answer.vue"),
  },
  {
    path: "/mock_analysis/:id/:m_id/:child_class",
    name: "mock_analysis",
    component: () => import("../views/mock/analysis.vue"),
  },
  {
    path: "/mock_result/:m_id/:child_class/:child_id",
    name: "mock_result",
    component: () => import("../views/mock/result.vue"),
  },
  {
    path: "/analysis_result/:m_id",
    name: "analysis_result",
    component: () => import("../views/mock/analysis_result.vue"),
  },
  // 历年真题
  {
    path: "/real_intro/:test_id",
    name: "real_intro",
    component: () => import("../views/real/intro.vue"),
  },
  {
    path: "/real_answer/:id",
    name: "real_answer",
    component: () => import("../views/real/answer.vue"),
  },
  {
    path: "/real_analysis/:id",
    name: "real_analysis",
    component: () => import("../views/real/analysis.vue"),
  },

  // 知识点练习/know_answer/:m_id/:k_id/:f_k_id
  // 错题关联  /know_answer/:m_id/:k_id/0  (m_id题型 k_id试题编号)
  {
    path: "/know_answer/:m_id/:k_id/:f_k_id",
    name: "know_answer",
    component: () => import("../views/knowledge/answer.vue"),
  },
  // 知识点练习/know_analysis/:m_id/:k_id
  // 错题关联  /know_analysis/:m_id/0  (m_id试卷id)
  {
    path: "/know_analysis/:m_id/:k_id",
    name: "know_analysis",
    component: () => import("../views/knowledge/analysis.vue"),
  },

  {
    path: "/wrong_answer/:subject_id/:k_id/:type",
    name: "wrong_answer",
    component: () => import("../views/wrong/answer.vue"),
  },

  {
    path: "*",
    name: "404",
    component: () => import("../views/404.vue"),
  },

  {
    path: "/ceshi",
    name: "ceshi",
    component: () => import("../views/ceshi.vue"),
  }
];

const router = new VueRouter({
  scrollBehavior: () => ({ y: 0 }), // 页面进入第二页回到顶部
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

import { ke_host } from "@/request/config.js";
//拦截器
router.beforeEach((route, redirect, next) => {
  if (
    route.name == "mock_answer" ||
    route.name == "mock_analysis" ||
    route.name == "mock_result" ||
    route.name == "confirm_answer" ||
    route.name == "real_answer" ||
    route.name == "real_analysis" ||
    route.name == "know_answer" ||
    route.name == "know_analysis" ||
    route.name == "wrong_answer" ||
    route.name == "analysis_result"
  ) {
    if (!getCookie("logined")) {
      // next()
      location.href = ke_host + "login?re_url=" + location.href;
      // next({
      //   path: "/login",
      //   query: { re_url: host + route.fullPath },
      // });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
